import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Link from "@mui/material/Link";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";

import { useTranslation } from "react-i18next";
import { FacebookSVG } from "~/assets/icons/facebook";
import AppleStore from "~/assets/SocialMedia/appleStoreEn.svg";
import GooglePlay from "~/assets/SocialMedia/googlePlayEn.svg";
import WofLogoSony from "~/assets/wof_logo_sony.webp";
import { APP_STORE_URL, FACEBOOK_URL, PLAY_STORE_URL, WHEEL_FORTUNE_URL } from "~/constants/urls";
import { useAuthStore } from "~/stores/auth";

import { LoginWithFacebook, LoginWithScopely } from "../../Auth";
import { PlayerProfile } from "../../Profile";

export function DrawerRight({
  handleCloseLogin,
  isLoading,
}: {
  isLoading: boolean;
  handleCloseLogin?: () => void;
}) {
  const { isAuthenticated } = useAuthStore();
  const { t } = useTranslation();

  const handleClick = () => {
    if (handleCloseLogin) {
      handleCloseLogin();
    }
  };

  const SOCIALMEDIA_ICON_SIZE = isAuthenticated ? 42 : 82;

  return (
      <Card
        sx={{
          height: "100%",
          minWidth: { xs: "", md: "264px" },
          maxWidth: "264px",
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
          zIndex: "-1",
        }}
      >
        <CardContent
          sx={{
            flex: "1 1 100%",
            display: "flex",
            flexDirection: "column",
            py: 4,
            px: 2,
          }}
        >
          <Box
            width="100%"
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            gap={2}
            sx={{ flex: "1 1 100%" }}
          >
            {isAuthenticated ? (
              <PlayerProfile isLoading={isLoading} />
            ) : (
              <Box display="flex" flexDirection="column" gap={1}>
                <LoginWithScopely />

                <LoginWithFacebook onError={handleClick} />
              </Box>
            )}
          </Box>

          <Box>
            <Box
              onClick={handleClick}
              sx={{
                width: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 1,
                flexDirection: isAuthenticated ? "row" : "column",
                mb: isAuthenticated ? 3 : 8,
              }}
            >
              <Link
                href={APP_STORE_URL}
                underline="none"
                target="_blank"
                sx={{
                  textDecoration: "none",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: isAuthenticated ? "112px" : "80%",
                }}
              >
                <img src={AppleStore} style={{ width: "100%" }} alt="" />
              </Link>

              <Link
                href={PLAY_STORE_URL}
                underline="none"
                target="_blank"
                sx={{
                  textDecoration: "none",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: isAuthenticated ? "112px" : "80%",
                }}
              >
                <img src={GooglePlay} style={{ width: "100%" }} alt="" />
              </Link>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                fontFamily="Inter"
                sx={{
                  color: "#382053",
                  ...(isAuthenticated
                    ? { fontWeight: "400", fontSize: "16px", lineHeight: 1, mb: 1 }
                    : { fontWeight: "900", fontSize: "26px", lineHeight: "30px", mb: 3.5 }),
                }}
              >
                {t("follow-us")}
              </Typography>

              <Box
                sx={{ display: "flex", alignItems: "center", gap: isAuthenticated ? 1 : 3 }}
                onClick={handleClick}
              >
                <Link href={FACEBOOK_URL} target="_blank" underline="none">
                  <SvgIcon
                    component={() =>
                      FacebookSVG({ width: SOCIALMEDIA_ICON_SIZE, height: SOCIALMEDIA_ICON_SIZE })
                    }
                    inheritViewBox={true}
                  />
                </Link>

                <Link href={WHEEL_FORTUNE_URL} target="_blank" underline="none">
                  <img
                    src={WofLogoSony}
                    alt=""
                    style={{
                      width: `${SOCIALMEDIA_ICON_SIZE}px`,
                      aspectRatio: 1,
                    }}
                  />
                </Link>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>
  );
}
